var echarts = require("../echarts");

require("./marker/MarkLineModel");

require("./marker/MarkLineView");

echarts.registerPreprocessor(function (opt) {
  // Make sure markLine component is enabled
  opt.markLine = opt.markLine || {};
});


//////////////////
// WEBPACK FOOTER
// ./~/_echarts@3.8.5@echarts/lib/component/markLine.js
// module id = 683
// module chunks = 115